<div class="bg-white">
  <div class="flex mb-3">
    <button
      p-button
      *ngIf="needPayment"
      (click)="paymentNavigation()"
      class="w-full rounded-lg p-3 text-white bg-primary text-center text-sm lg:text-base mb-2 cursor-pointer">
      {{ "receipt.regularizeMySituation" | translate }}
    </button>
  </div>
  <div *ngFor="let yearGroup of paymentSchedule">
    <div class="bg-lightest text-darkest px-4 py-1 font-semibold rounded">
      {{ yearGroup.year }}
    </div>
    <div
      class="bg-white"
      *ngFor="let payment of yearGroup.receipts">
      <div
        class="flex items-center justify-between p-4"
        [ngClass]="{
          'cursor-pointer': payment.statusCode === ReceiptStates.IMP,
        }"
        (click)="onReceiptClick(payment.statusCode)">
        <div class="text-darkest w-1/3">
          {{ payment.paymentDate | date: "d MMMM" | lowercase }}
        </div>
        <div
          class="text-center w-1/3"
          [ngClass]="getStatusClass(payment.status)">
          {{ payment.amount | currency: "EUR" : "symbol" : "" : "fr" }}
        </div>

        <div class="flex justify-end w-1/3">
          <app-status-card
            [status]="payment.statusCode"
            [statusConfig]="receiptStatusConfig"></app-status-card>
        </div>
      </div>
    </div>
  </div>
</div>
